<template>
  <div class="flex space-x-1">
    <Menu
      :class="[
        loading && 'pointer-events-none opacity-70',
        disabled && 'pointer-events-none',
      ]"
      :position="position"
      :align="align"
      noGap
    >
      <CoreButtonBase
        @click="emit('click')"
        :type="type"
        :disabled="disabled"
        :loading="loading"
      >
        <slot />
        <CoreIcon class="ml-1" icon-id="chevron" size="sm" />
      </CoreButtonBase>

      <template #content>
        <slot name="menu" />
      </template>
    </Menu>
  </div>
</template>

<script lang="ts" setup>
import CoreButtonBase from './CoreButtonBase.vue'

type ButtonType = 'primary' | 'secondary' | 'tertiary'
type Position = 'top' | 'right' | 'bottom' | 'left'
type Alignment = 'top' | 'right' | 'bottom' | 'left' | 'center'

const {
  disabled,
  loading,
  align,
  position,
  type = 'primary',
} = defineProps<{
  type?: ButtonType
  disabled?: boolean
  loading?: boolean
  position?: Position
  align?: Alignment
}>()

const emit = defineEmits<{
  click: []
}>()
</script>

<style lang="scss" scoped></style>
